// extracted by mini-css-extract-plugin
export default {"wrapper":"PaginationCompressed_wrapper__ZTRiL","inputWrapper":"PaginationCompressed_inputWrapper__5s5S5","input":"PaginationCompressed_input__rURWF"};